<template>
<div class="task-list">
  <div class="list">
    <div v-for="(item,index) in $state.taskList" v-show="index<taskListLength" :key="item" class="item">
      <div class="name">{{index+1}}、{{item.name}}</div>
      <div v-if="item.id!=='t_1'&&item.num===1" @click="clickTask(item,index)" class="btn">去完成</div>
      <div v-else-if="item.id==='t_1'&&item.num>0" @click="clickTask(item,index)" class="btn">去完成</div>
      <div v-else @click="clickTask(item,index)" class="btn active">已完成</div>
    </div>
    <div
      v-show="taskListLength<$state.taskList.length"
      @click="taskListLength=$state.taskList.length"
      class="more"
    >做任务增加游戏次数&gt;&gt;</div>
  </div>
</div>
</template>
<script>
import { jumpPage } from '../../mixins/functions'
export default {
  name: 'task-list',
  data() {
    return {
      taskListLength:1
    }
  },
  methods: {
    clickTask(item, index) {
      this.$storejs.set(`${this.$key}isTask`,true)
      if (item.url === '') {
        this.handlerShare()
      }else{
        this.doTask(item, index)
      }
    },
    handlerShare() {
      typeof _czc !== 'undefined' && _czc.push(['_trackEvent', `${this.$key}`, '做邀请任务'])
      this.$emit('jumpShare')
    },
    async doTask(item, index) {
      if (item.num === 0) {
        if (item.url.indexOf('alipays://') > -1) {
          window.location.href = item.url
        } else {
          ap.pushWindow(item.url)
        }
        return
      }
      const res = await this.$post({
        baseURL: this.$baseURL.cat,
        url: `/activity/${this.$key}/tasks/complete`,
        data: {
          tid:item.id
        }
      })
      if (res.code === 0) {
        if (item.url.indexOf('alipays://') > -1) {
          window.location.href = item.url
        } else {
          ap.pushWindow(item.url)
        }
        item.num = 0
        const arr = this.$state.taskList.splice(index, 1)
        this.$state.taskList.push(arr[0])
        if (res.data.chance > 0) {
          this.$state.userInfo.chance++
        }
      } else {
        this.$toast(res.msg)
      }
    },
  }
}
</script>

<style lang="scss" scoped>
.more{
  text-align: center;
  color: #00b5ff;
  padding: 10px 0;
  border-top:1px solid #fff4d0;
}
.list {
    width: 690px;
    margin:0 auto;
    background: #fff;
    padding: 20px 20px 0;
    border:4px solid #fe5e5c;
    box-sizing: border-box;
    border-radius: 25px;
    .item {
        display: flex;
        align-items: center;
        padding-bottom:20px;
        .name {
            flex: 1;
            line-height: 1.4;
            padding-right: 10px;
            color: #333;
            display: flex;
            align-items: center;
        }
        .btn {
            width: 120px;
            height: 50px;
            line-height: 50px;
            color: #fff;
            border-radius: 25px;
            text-align: center;
            background:  linear-gradient(#fcd127, #fc9827);
            &.active {
                border: 2px solid #888888;
                color: #fff;
                background: linear-gradient(to right, #888888, #8c8c8c);
            }
        }
    }
}
</style>
